import React, { useState } from 'react';
import { useClosest, useRounds } from '../../../Data/Rounds';
import Select from './Select';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import Button from '../../Button/Button';
import EditRound from '../../../Pages/Round/EditRound';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';

const Round = ({coordinates, label, name, help, onChange, disabled, validators, unselected, noRoundSelectedLabel, addRound}) => {
    const {rounds, refresh} = useRounds();
    const {closest} = useClosest(coordinates);
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? '';
    const {isValid, error} = useValidators(value, validators, name, updateValidity);
    const [addingRound, setAddingRound] = useState(false);

    useFieldPanelHelper(name, value, isValid);

    const handleChange = (roundId) => {
        updateField(name, roundId);
        onChange && onChange(roundId);
    }

    if (!rounds) {
        return <Select key="loading" label={label} options={[{value: '', label: 'Loading'}]} disabled />
    }

    const options = [{value: 'no-round', label: noRoundSelectedLabel ?? 'None'}, ...rounds.map(r => ({value: r.id, label: r.name}))];
    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <select
            key={value}
            id={name}
            name={name}
            className="block w-full ml-1 p-0 border-0 border-transparent focus:border-transparent text-gray-900 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
            defaultValue={value}
            onChange={e => handleChange(e.target.value)}
            disabled={isDisabled}
        >
            {unselected && <option value="">{unselected}</option>}

            {options.map((option, index) => {
                if (typeof option === 'string') {
                    return <option key={index} value={option}>{option}</option>
                } else {
                    return <option key={index} value={option.value}>{option.label}</option>
                }
            })}
        </select>

        {(addRound || closest) && <p className="text-sm text-gray-500 mt-2 pt-2 text-nowrap w-100 overflow-hidden border-t">
            {addRound && <Button size="sm"
                theme="light"
                label="Add round"
                icon="Plus"
                onClick={() => setAddingRound(true)}
                zeroMargin
            />}
            {closest && <Button
                size="sm"
                theme="light"
                selected={closest.id === value}
                className="ml-2"
                icon={closest.id === value ? 'Check' : 'LocationPin'}
                label={closest?.name}
                onClick={() => handleChange(closest?.id)}
                zeroMargin
            />}
        </p>}

        <EditRound
            round={{}}
            isOpen={addingRound}
            onClose={setAddingRound}
            onSave={async (round) => {
                await refresh();
                handleChange(round.roundId);
            }}
        />

    </CommonFieldWrapper>
}

export default Round;
